import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { IonContent } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { DepositMainLabels } from "src/app/interfaces/deposit-main-labels";
import { BalanceModel } from "src/app/models/balance-model";
import { AccountBalanceService } from "src/app/services/balance/account-balance.service";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { WithdrawalService } from "src/app/services/cashier/withdrawal.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { InteracModel } from "../../deposit/cashier-models/models";
import { WithdrawalBaseComponent } from "../withdrawal-base/withdrawal-base.component";

@Component({
    selector: 'page-withdrawal-interac',
    templateUrl: 'withdrawal-interac.html',
})
export class WithdrawalInteracPage extends WithdrawalBaseComponent implements OnInit {
    @ViewChild('Content') content: IonContent;

    public error = null;    
    public btnDisabled = false;
   // public hasAccount: boolean = false;
    public withdrawalForm: FormGroup;

    public amount: AbstractControl;
    public selectedAccount: AbstractControl;
    public currency_code: AbstractControl;
    public payment_type_code: AbstractControl;
    public labels: DepositMainLabels;

    public accounts: any = [];
    public accountBalances: BalanceModel;

    public ssnValue: string;

    public maxACHAccounts;

    public showAddAccounts: boolean = false;
    flatFee:number = 0;

    constructor(
        // private logger: Logger,
        private config: ConfigService,
        private balanceProvider: AccountBalanceService,
        private withdrawService:WithdrawalService,
        private navigator:Navigator,
        private cashierProvider: CashierService,
        private events: EventsService,
        private successMessageService: SuccessMessageService,
        private contentProvider: CashierContentService
    ){
        super();
        this.labels = new InteracModel();
        this.successMessageService.clearMessage();
        this.error = null;
    }

    ngOnInit() {
        this.maxACHAccounts = this.config.getConfig().FEATURE_ECHECK_NUM_ACCTS || 1;
        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                //selectedAccount: new FormControl('', [Validators.required]),
                currency_code: new FormControl(''),
                payment_type_code: new FormControl(''),
            }
        )

        this.amount = this.withdrawalForm.get('amount');
       // this.selectedAccount = this.withdrawalForm.get('selectedAccount');


    }

    ionViewWillEnter() {
        //this.onGetAccounts();
        this.contentProvider
        .getPageConfig("interac")
        .then((response: DepositMainLabels) => {
          this.labels = response;
        });
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad WithdrawalECheckPage');
    }

    ionViewDidEnter() {
        
        this.onGetBalance();
        this.withdrawService.getPayoutMethods().subscribe((res:any) =>{
            for(const paymentMethod of res){  
                if(paymentMethod?.PAYMENT_TYPE?.code === 'GDIE'){
                    this.flatFee = paymentMethod?.FLAT_FEE;
                    break;
                }
            }
        })
    }

    onInputChange(target) {
    }

    onGetBalance() {

        this.balanceProvider.getBalance().subscribe(
            (balance: BalanceModel) => {
                if (balance) {
                    this.accountBalances = balance;
                }
            }
        );
        this.error = null;
    }
    

    onGetAccounts() {
        this.accounts = [];
        this.cashierProvider.callListAccounts().subscribe(
            (response) => {
                if (response.result) {
                    var tempAccounts: any = response.payload;
                    for (let index in tempAccounts) {
                        if (tempAccounts[index].paymentTypeCode == "GDIE" && this.accounts.length < 4) {
                            this.accounts.push(tempAccounts[index]);
                            //this.hasAccount = true;
                            // do not allow SIN update in this case
                            if (typeof tempAccounts[index].accountAdditionalInfo3 != 'undefined') {
                                    this.ssnValue = tempAccounts[index].accountAdditionalInfo3;
                            }
                        }
                    }
                    this.showAddAccounts = true;
                }
                else {
                    // this.logger.error('Failed to get accounts');
                }
            }
        );
    }

    onAddNewAccount() {
        return this.navigator.navigateTo("WithdrawalInteracAddPage", {multipleModals: true}, {ssnValue: this.ssnValue});
    }

    submit() {
        this.btnDisabled = true;
        this.successMessageService.clearMessage();
        this.error = null;

        //var accountIndex: AbstractControl = this.withdrawalForm.get("selectedAccount");

        //this.withdrawalForm.get("customerAccountID").setValue(this.accounts[accountIndex.value].customerAccountID);
        this.withdrawalForm.get("currency_code").setValue(this.cashierProvider.customer.preferredCurrency.currencyCode);
        this.withdrawalForm.get("payment_type_code").setValue("GDIE");

        // this.logger.log('onDeposit WithdrawalECheckPage', this.withdrawalForm.value);

        this.withdrawService.callWithdraw(this.withdrawalForm.value).subscribe(
            (response: any) => {
                // this.logger.log("callWithdraw response = ", response);
                if (response && !!response.result ) {

                    // send the withdrawal event
                    let depositEventData = {
                        customerId: this.cashierProvider.customer.customerId,
                        amount:     this.withdrawalForm.get('amount').value
                    }
                    setTimeout(() => this.events.publish('event:withdraw', depositEventData ), 2000);

                    this.amount.setValue('');
                    this.amount.markAsPristine();

                    this.successMessageService.setMessage('Your withdrawal request has been received.');

                    this.balanceProvider.updateBalance();

                    this.content.scrollToTop();
                    this.btnDisabled = false;
                }
            },
            (error) => {
                this.btnDisabled = false;
                // handle all deposit errors in base
                this.error = this.handleError(error);
                // this.logger.log("callWithdraw error = ", error);
            }
        )

        this.error = null;
    }
}
